import {ApplicationStatus} from "./ApplicationStatus";

const ApplicationType = {
  DataOnly: { value: "DATA_ONLY", label: "Data only (v1)" },
  DataAndSamples: { value: "DATA_AND_SAMPLES", label: "Data + Samples" },
  DataOnlyV2: { value: "DATA_ONLY_V2", label: "Data only (v2)"}
}

const applicationTypeByValue = new Map<string, typeof ApplicationType[keyof typeof ApplicationType]>(
    Object.values(ApplicationType).map((entry) => [entry.value, entry])
);


const getTypeLabel = (applicationType: string)=> {
  const type = applicationTypeByValue.get(applicationType);
  if (type) {
    return type.label;
  } else {
    return "UNKNOWN APP TYPE";
  }
}

export {getTypeLabel}